import Repository from "@/repositories/Repository";

const resourceOrder = `${Repository.defaults.orderApi}/console`;
const resource = Repository.defaults.baseURL;
const resourcePayment = `${Repository.defaults.paymentApi}/console`;

// List API
const API = {
  ORDER: "orders",
  ORDER_DETAIL: "orders/:orderId",
  LIST_PRODUCT: "products",
  LIST_CUSTOMER: "customers",
  PROVINCE: "address",
  DISTRICT: "address/:provinceId",
  WARD: "address/:provinceId/:districtId",
  CANCEL: "orders/:orderId/update-status",
  FILTER: "payment/get-filter-form-options",
  RECEIPT: "payment/create",
  DETAIL_RECEIPT: "payment/:transectionId/inquire",
  CONFIRM_RECEIPT: "payment/:transectionId/update-status",
  UPDATE_RECEIPT: "payment/:transactionNumber",
};

export default {
  // Tạo mới đơn hàng
  async createOrder(data) {
    const response = await Repository({
      method: "POST",
      url: `${resourceOrder}/${API.ORDER}`,
      data,
    });
    return response;
  },

  // Huỷ đơn hàng
  async cancelOrder(orderId, data) {
    const response = await Repository({
      method: "PATCH",
      url: `${resourceOrder}/${API.CANCEL.replace(":orderId", orderId)}`,
      data,
    });
    return response;
  },

  // Lấy chi tiết đơn hàng
  async detailOrder(orderId, params) {
    const response = await Repository({
      method: "GET",
      url: `${resourceOrder}/${API.ORDER_DETAIL.replace(":orderId", orderId)}`,
      params,
    });
    return response;
  },

  // Lấy danh sách sản phẩm
  async listProduct(params) {
    const response = await Repository({
      method: "GET",
      url: `${resourceOrder}/${API.LIST_PRODUCT}`,
      params,
    });
    return response;
  },

  // Lấy danh sách khách hàng
  async listCustomer(params) {
    const response = await Repository({
      method: "GET",
      url: `${resourceOrder}/${API.LIST_CUSTOMER}`,
      params,
    });
    return response;
  },

  // Lấy danh sách filter
  async listFilter() {
    const response = await Repository({
      method: "GET",
      url: `${resourceOrder}/${API.FILTER}`,
    });
    return response;
  },

  // Tạo phiếu thu
  async createReceipt(data) {
    const response = await Repository({
      method: "POST",
      url: `${resourcePayment}/${API.RECEIPT}`,
      data,
    });
    return response;
  },

  // Chi tiết phiếu thu
  async detailReceipt(transectionId) {
    const response = await Repository({
      method: "GET",
      url: `${resourcePayment}/${API.DETAIL_RECEIPT.replace(
        ":transectionId",
        transectionId
      )}`,
    });
    return response;
  },

  // Xác nhận phiếu thu
  async confirmReceipt(transectionId, data) {
    const response = await Repository({
      method: "PATCH",
      url: `${resourceOrder}/${API.CONFIRM_RECEIPT.replace(
        ":transectionId",
        transectionId
      )}`,
      data,
    });
    return response;
  },

  // Cập nhật phiếu thu
  async updateReceipt(transactionNumber, data) {
    const response = await Repository({
      method: "PATCH",
      url: `${resourceOrder}/${API.UPDATE_RECEIPT.replace(
        ":transactionNumber",
        transactionNumber
      )}`,
      data,
    });
    return response;
  },

  // Lấy danh sách Tỉnh/Thành Phố
  async listProvince() {
    const params = {
      limit: 100,
    };
    const response = await Repository({
      method: "GET",
      url: `${resource}/${API.PROVINCE}`,
      params,
    });
    return response;
  },

  // Lấy danh sách Quận/Huyện
  async listDistrict(provinceId) {
    const params = {
      limit: 100,
    };
    const response = await Repository({
      method: "GET",
      url: `${resource}/${API.DISTRICT.replace(":provinceId", provinceId)}`,
      params,
    });
    return response;
  },

  // Lấy danh sách Phường/Xã
  async listWard({ provinceId, districtId }) {
    const params = {
      limit: 100,
    };
    const response = await Repository({
      method: "GET",
      url: `${resource}/${API.WARD.replace(":provinceId", provinceId).replace(
        ":districtId",
        districtId
      )}`,
      params,
    });
    return response;
  },
};
